export default function init() {
  document.querySelectorAll("[data-media-share]").forEach(link => {
    link.addEventListener("click", e => {
      window.open(e.currentTarget.href, "pop", "width=600, height=400")
      e.preventDefault()
    })
  })
}
